import POSTAL_CODE_TO_ADDRESS from './postalCodeToAddress.gql';

export default POSTAL_CODE_TO_ADDRESS;
export { POSTAL_CODE_TO_ADDRESS };
